function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentCashOnlyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16a5 5 0 11-10 0 5 5 0 0110 0zm-2 0a3 3 0 11-6 0 3 3 0 016 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10a2 2 0 012-2h24a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V10zm24 0h2v2c-.34 0-.872-.11-1.29-.412-.368-.264-.71-.714-.71-1.588zm-2 0H8c0 1.526-.658 2.576-1.54 3.211A4.35 4.35 0 014 14v4c.66 0 1.628.19 2.46.788C7.341 19.424 8 20.474 8 22h16c0-1.526.658-2.576 1.54-3.212A4.35 4.35 0 0128 18v-4a4.35 4.35 0 01-2.46-.789C24.659 12.576 24 11.526 24 10zm4 12h-2c0-.874.342-1.324.71-1.588.418-.302.95-.412 1.29-.412v2zM5.29 20.412c.368.264.71.714.71 1.588H4v-2c.34 0 .872.11 1.29.412zM6 10H4v2c.34 0 .872-.11 1.29-.412.368-.264.71-.714.71-1.588z",
    fill: props.color
  }));
}

export default SvgIconPaymentCashOnlyFilled;